import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './name-text-cell.scss';

class TextCell extends React.Component {
  static propTypes = {
    value: PropTypes.string,
    title: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
    query: PropTypes.string,
  };

  renderValue = () => {
    const { query, value } = this.props;
    if (!query) return value;
    const matcher = new RegExp(`(${query})`, 'gi');

    const matches = value.split(matcher);
    return matches.map((match, i) => {
      if (match.toLowerCase() === query.toLowerCase()) {
        return (
          <span className={styles.matchedCharacters} key={`matches${i}`}>
            {match}
          </span>
        );
      }
      return match;
    });
  };

  render() {
    const title = this.props.title || this.props.value;
    return (
      <div className={classnames(styles.cell, this.props.className)} title={title}>
        <span className={this.props.onClick ? styles.link : null} onClick={this.props.onClick}>
          {this.renderValue()}
        </span>
      </div>
    );
  }
}

export default TextCell;
